import {v4} from 'uuid';

export default function uuid4(){

    const uuid = v4();

    return uuid;
}
